export enum ModuleAccessRightDenyReason {
  MISSING_USER_RIGHT = 'MISSING_USER_RIGHT',
  COMPANY_NO_LICENSE = 'COMPANY_NO_LICENSE',
  USER_NO_LICENSE = 'USER_NO_LICENSE',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  NOT_ALLOWED_FOR_NON_FULL_USERS = 'NOT_ALLOWED_FOR_NON_FULL_USERS',
  DEPENDENCY_MAR_HAS_NO_ACCESS = 'DEPENDENCY_MAR_HAS_NO_ACCESS',
  NOT_ALLOWED_FOR_LIGHT_USER = 'NOT_ALLOWED_FOR_LIGHT_USER',
  MISSING_LEGACY_WIDGET_VISIBILITY = 'MISSING_LEGACY_WIDGET_VISIBILITY',
}
